import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { configure } from 'axios-hooks';

import { client, configureStore, history } from './redux/store';

import App from './App';
import './i18n';
import 'semantic-ui-less/semantic.less';

export const store = configureStore();

configure({ axios: client });

const rootElement = document.getElementById('root');
ReactDOM.render(
  <Provider store={store}>
    <App history={history} />
  </Provider>,
  rootElement
);
